<script context="module">
  export const Constants = /** @type {const} */ ({
    DynamicHeadingContext: "DynamicHeadingContext",
    MaximumHeadingLevel: 6,
    HeadingIncrement: 1
  });
</script>

<script>
  import { setContext, getContext } from "svelte";

  const dynamicHeading = getContext(Constants.DynamicHeadingContext);
  if (!dynamicHeading) {
    setContext(Constants.DynamicHeadingContext, 1);
  } else {
    setContext(
      Constants.DynamicHeadingContext,
      dynamicHeading > Constants.MaximumHeadingLevel
        ? Constants.MaximumHeadingLevel
        : dynamicHeading + Constants.HeadingIncrement
    );
  }
</script>

<!--
@component
This component defines the Heading level for the DynamicHeading component
every time this is nested in another DynamicHeading component, the level is incremented by 1
eg:
```svelte
<DynamicHeadingContext>
  <DynamicHeading>This is an h1</DynamicHeading>
  <DynamicHeadingContext>
    <DynamicHeading>This is an h2</DynamicHeading>
    <DynamicHeadingContext>
      <DynamicHeading>This is an h3</DynamicHeading>
    </DynamicHeadingContext>
  </DynamicHeadingContext>
</DynamicHeadingContext>
-->
<slot />
